import React from 'react'
import { Box, LinearProgress, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { DashboardTablePaper } from 'components'

import useStyles from './styles'

const PrivacyPolicyAcceptanceTable = ({ title, privacyPolicies, ...rest }) => {
  const classes = useStyles()

  return (
    <DashboardTablePaper
      title={title}
      tableType="privacyPolicy"
      className={classes.root}
      {...rest}
    >
      {privacyPolicies?.map((privacyPolicy) => (
        <Box px={2} key={privacyPolicy.id}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>
              {privacyPolicy.title}
            </Typography>
            <Typography className={classes.rowValue}>
              {privacyPolicy.acceptedTotal}
              {privacyPolicy.acceptedPrivate && '%'}
            </Typography>
          </Box>
          <Box>
            <LinearProgress
              className={classes.lineBar}
              variant="determinate"
              value={
                privacyPolicy.acceptedPrivate ? privacyPolicy.percentage : 100
              }
            />
          </Box>
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

PrivacyPolicyAcceptanceTable.propTypes = {
  title: PropTypes.string,
  privacyPolicies: PropTypes.array,
}

export default PrivacyPolicyAcceptanceTable
